import { apiDelete, apiJson, API_PATH_ADMIN } from './client.js'

const base = `${API_PATH_ADMIN}/onboarding`

export function listOnboardingSessions(modelId) {
  return apiJson(`${base}/models/${modelId}`, {}, 'Failed to load onboarding sessions')
}

export function startOnboardingSession(modelId, settings = {}) {
  return apiJson(
    `${base}/models/${modelId}`,
    { method: 'POST', body: JSON.stringify({ settings }) },
    'Failed to start onboarding',
  )
}

export function getOnboardingSession(sessionId) {
  return apiJson(`${base}/${sessionId}`, {}, 'Failed to load onboarding')
}

export function updateOnboardingSession(sessionId, payload = {}) {
  return apiJson(
    `${base}/${sessionId}`,
    { method: 'PATCH', body: JSON.stringify(payload) },
    'Failed to update onboarding',
  )
}

export function cancelOnboardingSession(sessionId, expectedStateVersion) {
  return apiJson(
    `${base}/${sessionId}/cancel`,
    {
      method: 'POST',
      body: JSON.stringify({ expected_state_version: expectedStateVersion }),
    },
    'Failed to cancel onboarding',
  )
}

export function addOnboardingSource(sessionId, payload) {
  return apiJson(
    `${base}/${sessionId}/sources`,
    { method: 'POST', body: JSON.stringify(payload) },
    'Failed to add onboarding source',
  )
}

export function uploadOnboardingSource(sessionId, { file, ...fields }) {
  const body = new FormData()
  body.append('file', file)
  Object.entries(fields).forEach(([key, value]) => {
    if (value != null && value !== '') body.append(key, String(value))
  })
  return apiJson(
    `${base}/${sessionId}/sources/upload`,
    { method: 'POST', body, skipContentType: true },
    'Failed to upload onboarding document',
  )
}

export function removeOnboardingSource(sessionId, sourceId) {
  return apiDelete(`${base}/${sessionId}/sources/${sourceId}`, 'Failed to remove onboarding source')
}

export function importOnboardingHistory(sessionId, payload = {}) {
  return apiJson(
    `${base}/${sessionId}/history-import`,
    { method: 'POST', body: JSON.stringify(payload) },
    'Failed to import historical conversations',
  )
}

export function analyzeOnboarding(sessionId, payload = {}) {
  return apiJson(
    `${base}/${sessionId}/analyze`,
    { method: 'POST', body: JSON.stringify(payload) },
    'Failed to queue onboarding analysis',
  )
}

export function reviewOnboardingCandidate(sessionId, candidateId, payload) {
  return apiJson(
    `${base}/${sessionId}/candidates/${candidateId}`,
    { method: 'PATCH', body: JSON.stringify(payload) },
    'Failed to review candidate',
  )
}

export function reviewOnboardingFinding(sessionId, findingId, payload) {
  return apiJson(
    `${base}/${sessionId}/findings/${findingId}`,
    { method: 'PATCH', body: JSON.stringify(payload) },
    'Failed to review audit finding',
  )
}

export function updateOnboardingDraft(sessionId, payload) {
  return apiJson(
    `${base}/${sessionId}/draft`,
    { method: 'PATCH', body: JSON.stringify(payload) },
    'Failed to save onboarding draft',
  )
}

export function updateOnboardingMonetization(sessionId, payload) {
  return apiJson(
    `${base}/${sessionId}/monetization`,
    { method: 'PATCH', body: JSON.stringify(payload) },
    'Failed to save monetization plan',
  )
}

export function evaluateOnboardingReadiness(sessionId) {
  return apiJson(
    `${base}/${sessionId}/readiness`,
    { method: 'POST', body: JSON.stringify({}) },
    'Failed to evaluate onboarding readiness',
  )
}

export function createOnboardingRelease(sessionId, label = '') {
  return apiJson(
    `${base}/${sessionId}/releases`,
    { method: 'POST', body: JSON.stringify({ label: label || undefined }) },
    'Failed to create release snapshot',
  )
}

export function testOnboardingRelease(sessionId, releaseId) {
  return apiJson(
    `${base}/${sessionId}/releases/${releaseId}/test`,
    { method: 'POST', body: JSON.stringify({ run_behavior_checks: true }) },
    'Failed to run release preflight',
  )
}

export function publishOnboardingRelease(sessionId, releaseId, payload) {
  return apiJson(
    `${base}/${sessionId}/releases/${releaseId}/publish`,
    { method: 'POST', body: JSON.stringify(payload) },
    'Failed to publish onboarding release',
  )
}

export function rollbackOnboardingRelease(sessionId, releaseId) {
  return apiJson(
    `${base}/${sessionId}/releases/${releaseId}/rollback`,
    { method: 'POST', body: JSON.stringify({}) },
    'Failed to roll back onboarding release',
  )
}
